module.exports = __webpack_public_path__ + "img/grenada-2.82bf7a6f.png";